<template>
  <div class="page">
    <Language v-if="state === 'selectLanguage'" />
    <Login v-if="state === 'login'" />
    <Chapter1 v-if="state === 'chapter1'" />
    <Pause1 v-if="state === 'beforeChapter2'" />
    <Chapter2 v-if="state === 'chapter2'" />
    <Pause2 v-if="state === 'beforeChapter3'" />
    <Chapter3 v-if="state === 'chapter3'" />
    <Pause3 v-if="state === 'beforeChapter4'" />
    <Chapter4 v-if="state === 'chapter4'" />
    <Pause4 v-if="state === 'beforeChapter5'" />
    <Chapter5 v-if="state === 'chapter5'" />
    <Chapter6 v-if="state === 'chapter6'" />
  </div>
</template>

<script>
// @ is an alias to /src
import Language from '@/components/Language.vue'
import Login from '@/components/Login.vue'
import Chapter1 from '@/components/Chapter1.vue'
import Pause1 from '@/components/Pause1.vue'
import Chapter2 from '@/components/Chapter2.vue'
import Pause2 from '@/components/Pause2.vue'
import Chapter3 from '@/components/Chapter3.vue'
import Pause3 from '@/components/Pause3.vue'
import Chapter4 from '@/components/Chapter4.vue'
import Pause4 from '@/components/Pause4.vue'
import Chapter5 from '@/components/Chapter5.vue'
import Chapter6 from '@/components/Chapter6.vue'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    Language, Login, Chapter1, Pause1, Chapter2, Pause2, Chapter3, Pause3, Chapter4, Pause4, Chapter5, Chapter6
  },
  data: function () {
    return {
      pw: 'asdkfjhtmnbvasdfknedsfDSF',
      state: '',
      loggedIn: false,
      chapterTimer: [20, 10, 15, 10, 10]
    }
  },
  computed: mapState(['gameState', 'gameUpdate']),
  watch: {
    gameState (newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`)
      this.state = newValue
    },
    gameUpdate (newValue, oldValue) {
      if (newValue) {
        this.$store.commit('reloadGameData', false)
        this.getGameState()
      }
    }
  },
  methods: {
    dispatch: function (response) {
      console.log('dispatch', response)
      // Check if favorite language has been selected
      if (!this.$store.state.languageChoosen) {
        this.$store.commit('updateGameState', 'selectLanguage')
        return
      }
      // check if the user has allready logged in
      if (!(this.$store.state.username && this.$store.state.teamname)) {
        if (!this.checkLogin()) {
          this.$store.commit('updateGameState', 'login')
          return
        }
      }
      // Select Chapter
      if (response.data.gameTimer[0] === null) {
        this.$store.commit('updateGameState', 'login')
        return
      }
      if (response.data.gameTimer[4] !== null && this.timeLeft(response.data.gameTimer[4], this.chapterTimer[4]) === 0) {
        this.$store.commit('updateGameState', 'chapter6')
      } else if (response.data.gameTimer[4] !== null) {
        this.$store.commit('updateCurrentChapter', { chapter: 5, timer: this.toSeconds(response.data.gameTimer[4]), duration: this.chapterTimer[4] })
        this.$store.commit('updateGameState', 'chapter5')
      } else if (response.data.gameTimer[3] !== null && this.timeLeft(response.data.gameTimer[3], this.chapterTimer[3]) === 0) {
        this.$store.commit('updateGameState', 'beforeChapter5')
      } else if (response.data.gameTimer[3] !== null) {
        this.$store.commit('updateCurrentChapter', { chapter: 4, timer: this.toSeconds(response.data.gameTimer[3]), duration: this.chapterTimer[3] })
        this.$store.commit('updateGameState', 'chapter4')
      } else if (response.data.gameTimer[2] !== null && this.timeLeft(response.data.gameTimer[2], this.chapterTimer[2]) === 0) {
        this.$store.commit('updateGameState', 'beforeChapter4')
      } else if (response.data.gameTimer[2] !== null) {
        this.$store.commit('updateCurrentChapter', { chapter: 3, timer: this.toSeconds(response.data.gameTimer[2]), duration: this.chapterTimer[2] })
        this.$store.commit('updateGameState', 'chapter3')
      } else if (response.data.gameTimer[1] !== null && this.timeLeft(response.data.gameTimer[1], this.chapterTimer[1]) === 0) {
        this.$store.commit('updateGameState', 'beforeChapter3')
      } else if (response.data.gameTimer[1] !== null) {
        this.$store.commit('updateCurrentChapter', { chapter: 2, timer: this.toSeconds(response.data.gameTimer[1]), duration: this.chapterTimer[1] })
        this.$store.commit('updateGameState', 'chapter2')
      } else if (response.data.gameTimer[0] !== null && this.timeLeft(response.data.gameTimer[0], this.chapterTimer[0]) === 0) {
        this.$store.commit('updateGameState', 'beforeChapter2')
      } else if (response.data.gameTimer[0] !== null) {
        this.$store.commit('updateCurrentChapter', { chapter: 1, timer: this.toSeconds(response.data.gameTimer[0]), duration: this.chapterTimer[0] })
        this.$store.commit('updateGameState', 'chapter1')
      }
    },
    timeLeft: function (timer, duration) {
      const d = new Date()
      let timeLeft = (this.toSeconds(timer) + duration * 60) - (d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds())
      if (timeLeft < 0) timeLeft = 0
      return timeLeft
    },
    toSeconds: function (timer) {
      const splitted = timer.split(':')
      if (splitted.length === 3) {
        return parseInt(splitted[0]) * 3600 + parseInt(splitted[1]) * 60 + parseInt(splitted[2])
      } else {
        return 0
      }
    },
    getGameState: function () {
      console.log('getGameState')
      axios.get('http://admin.tabbot-central.com/getGameData.php', {
        params: {
          token: this.pw,
          user: this.$store.username
        }
      }).then(this.dispatch).catch(error => {
        console.log(error)
        this.error = true
      })
    },
    checkLogin: function () {
      const cookies = document.cookie.split('; ').reduce((prev, current) => {
        const [name, value] = current.split('=')
        prev[name] = value
        return prev
      }, {})
      if (cookies.gamedate) {
        const d = new Date()
        if (cookies.gamedate !== '' + d.getFullYear() + d.getMonth() + d.getDate()) {
          return false
        }
      } else {
        return false
      }
      if (cookies.teamname) {
        this.$store.commit('setTeamname', cookies.teamname)
      }
      if (cookies.username) {
        this.$store.commit('setUsername', cookies.username)
      }
      if (this.$store.state.username && this.$store.state.teamname) {
        return true
      } else {
        return false
      }
    }
  },
  created: function () {
    this.getGameState()
  }
}
</script>
